import React from "react";
import ProfilePage from "../../components/Profile/ProfilePage";

const Profile = () => {
  return <ProfilePage />;
};

export default Profile;
